function searchResultsLinkService (historyStateService, sessionStorageService) {
    const SRP_URL = 'srp-url';

    return {
        getBackToSrpUrl,
        getSeoUrl,
        getSeoLinkText,
        getMatchMakerUrl
    };

    function getMatchMakerUrl () {
        return (historyStateService.referrer().indexOf('/matchmaker/quiz') > 0) ? historyStateService.referrer() : undefined;
    }

    function getBackToSrpUrl ({listingId}) {
        if (showSrpUrl()) {
            let url = '';

            if (historyStateService.referrer().indexOf('searchresults.action') > 0) {
                url = historyStateService.referrer();
                url = buildListingSpecificSrpUrl(url, listingId);
            } else {
                url = sessionStorageService.getItem(SRP_URL);
                url = buildListingSpecificSrpUrl(url, listingId);
            }

            return url;
        }
    }

    function getSeoUrl (listing) {
        let { canonicMakeName, isNewCarStockType, canonicModelName, modelYear, zipcode } = listing;
        let url = '/shopping/';

        if (canonicMakeName) {
            url += isNewCarStockType ? 'new/' : 'used/';
            url += canonicMakeName.replace(/-/g, '_');

            if (canonicModelName) {
                url += '-' + buildModelName(canonicModelName);
                url += '-' + modelYear;
            }

            url += '/';

            if (zipcode) {
                url += '?zc=' + zipcode + '&rd=30';
            }
        }

        return url.toLowerCase().replace(/ /g, '_');
    }

    function buildModelName(modelName){
        let returnModel = modelName.replace(/-/g, '_');
        returnModel = returnModel.replace('&', 'and');
        //check if is f_150, 250, 350 this is only necessary until listings api gets canonicals from MDIS
        let vehiclesNoUnderscore = ['f_150', 'f_250', 'f_350', 'f_450'];
        if (vehiclesNoUnderscore.indexOf(returnModel.toLowerCase()) > -1) {
            returnModel = returnModel.replace('_', '');
        }
        return returnModel;
    }

    function getSeoLinkText (listing) {
        let { stockTypeCode, modelYear, makeName, modelNameForAd } = listing;
        let pluralModelNameForAd;
        if (modelNameForAd) {
            if (modelNameForAd.endsWith('X') || modelNameForAd.endsWith('S')) {
                pluralModelNameForAd = `${modelNameForAd} `;
            } else {
                pluralModelNameForAd = modelNameForAd.endsWith('s') || modelNameForAd.endsWith('x') ? `${modelNameForAd}es` : `${modelNameForAd}s`;
            }
        } else {
            pluralModelNameForAd = '';
        }


        return [
            stockTypeCode,
            modelYear,
            makeName,
            pluralModelNameForAd
        ].join(' ');
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////

    function showSrpUrl() {
        return historyStateService.referrer().indexOf('searchresults.action') > 0
            || sessionStorageService.getItem(SRP_URL) !== null;
    }

    function buildListingSpecificSrpUrl (url, listingId) {
        url += (url.indexOf('?') > -1)
            ? '&moveTo=listing-' + listingId
            : '?moveTo=listing-' + listingId;
        return url;
    }
}

searchResultsLinkService.$inject = [
    'historyStateService',
    'sessionStorageService'
];

export default searchResultsLinkService;
